<div
  class="container"
  [ngClass]="{
    medium: size === 'medium',
    large: size === 'large',
  }"
>
  <div class="container__list">
    <ts-filter-list
      [fields]="fields"
      [filters]="filters"
      [hasGroups]="hasGroups"
      [lookupContract]="lookupContract"
      (filterDefChanged)="filterDefChange.emit($event)"
      (filterRemoved)="filterRemove.emit($event)"
    >
    </ts-filter-list>
  </div>
  <div class="container__actions">
    <ts-button type="flat" data-testid="add-new-filter" color="basic" icon="add" (buttonClick)="addItem.emit()"
      >Add filter</ts-button
    >
  </div>
  <div class="container__bottom">
    <a href="https://help.termsheet.com/add-filters-to-views" target="_blank">
      <mat-icon>help_outline</mat-icon> Learn about filters
    </a>
    <div>
      <ts-button
        type="stroked"
        color="accent"
        (buttonClick)="filterClear.emit()"
        [disabled]="!filters?.length"
        data-testid="clear-button"
        >Clear</ts-button
      >
      <ts-button
        type="flat"
        (buttonClick)="filterApply.emit()"
        [disabled]="!canFilter()"
        data-testid="apply-filter-button"
        >Apply</ts-button
      >
    </div>
  </div>
</div>
